export default __webpack_public_path__ + "static/media/EmailSent.67899b20.svg";